<template>
  <div class="h-dialogContainer">
    <p>{{$t('System.telephoneOrEmail')}}</p>
    <form id="createUserForm">
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">*{{$t('Login.username')}}</div>
            <input class="e-input e-input-group"
                         :placeholder='$t("Login.username")'
                         id="userName"
                         name="UserName"
                         v-model="userName"
                         @blur="setChildProps"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('System.telephone')}}</div>
            <input
              class="e-input"
              :placeholder='$t("System.telephone")'
              id="telephone"
              name="Telephone"
              v-model="telephone"
              @blur="setChildProps" />
          </div>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('System.email')}}</div>
            <input
              class="e-input"
              :placeholder='$t("System.email")'
              id="email"
              name="Email"
              v-model="email"
              @blur="setChildProps"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('System.description')}}</div>
            <ejs-textbox
              :placeholder='$t("System.description")'
              id="userDescription"
              name="Description"
              v-model="description"
              :multiline="true"
              @blur="setChildProps"
            />
          </div>
        </div>
      </div>
    </div>
    </form>
  </div>
</template>

<script>
import mixin from '../../mixin/mixin';

export default {
  name: "CreateUser",
  mixins: [mixin],
  data() {
    return {
      userName: '',
      telephone: '',
      email: '',
      description: '',
      formObj: '',
      inputNames: ['UserName', 'Telephone', 'Email', 'Description'],
      rules: {
        UserName: { required: true, regex: 'specialWordWithSpace', maxLength:16 },
        Telephone: { number: true, minLength: 11, maxLength: 11 },
        Email: { email: true },
        Description: { maxLength: 64 }
      }
    };
  },
  methods: {
    setChildProps() {
      let childProps = {
        name: this.userName,
        tel: this.telephone,
        mail: this.email,
        describe: this.description
      };
      this.$emit("childProps", childProps);
    },
    validate() {
      return this.formObj.validate();
    },
    bindValidate() {
      this.formObj = this.validateForm('createUserForm', this.inputNames, this.rules);
    },
    init(editParams){
      document.getElementById('userName').disabled = true;
      this.userName = editParams.name;
      this.telephone = editParams.tel;
      this.email = editParams.mail;
      this.description = editParams.describe;
    }
  }
};
</script>

<style>
</style>
